import listActionTypes from "./actiontypes"

const { FETCH_LIST } = listActionTypes

export function fetchLibraryCategoriesList() {
  return {
    type: FETCH_LIST,
  }
}
